import React from 'react';
import { isEmpty, isObjectEmpty } from '@libs/shared';
import classNames from 'classnames';
import { Intl } from '../../constants';

interface ICheckItem {
    required: boolean;
    regex?: string;
    tipClassName?: string; // errorTip class
    tipVisible: boolean;
    value: any;
    children?: React.ReactNode;
}

/**
 * 填写项校验组件
 *
 * @param props
 */
const CheckItem: React.FC<ICheckItem> = (props) => {
    const { tipClassName, required, regex, tipVisible, children, value } = props;
    const renderTip = () => {
        if (!tipVisible) {
            return null;
        }
        const className = classNames('check-item-tip', tipClassName);
        if (required && isObjectEmpty(value)) {
            return <div className={className}>{Intl.get('item.required')}</div>;
        }
        if (regex && !new RegExp(regex).test(value) && !isEmpty(value)) {
            return <div className={className}>{Intl.get('form.item.error.format')}</div>;
        }
    };

    if (!children) {
        return null;
    }

    return (
        <div className="fx-check-item">
            {children}
            {renderTip()}
        </div>
    );
};
export default CheckItem;
